import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';
import { Ticket } from '@/app/models/interface/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.socketApi + 'ticket/';

  create(data: FormData) {
    return this.http.post<CustomResponse<Ticket>>(this.url, data).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<CustomResponse<PaginatorModel<Ticket[], HasPagination>>>(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: string) {
    const url = this.url + id;
    return this.http.get<CustomResponse<Ticket>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<Ticket>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<Ticket>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }
}
